export default __webpack_public_path__ + "static/media/imagetop.ba4cbc2a.png";